<template>
  <aha-tab-item
    :title="titleLogOutEverywhereElse"
  >
    <aha-section>
      <template #header>
        <h5>{{ $i18nPresenter.t('Log out everywhere else') }}</h5>
      </template>
      <template #body>
        <div class="pb-2">
          <div class="pb-2">
            {{
              // eslint-disable-next-line max-len
              $i18nPresenter.t('This will log you out from all other devices and browsers. You will still stay logged in on this device.')
            }}
          </div>
        </div>

        <aha-antd-button
          v-aha-emit-action
          name="logout-everywhere-else"
          :submitting="logoutLoading"
          is-loading-inline
          variant="danger"
          @click="logoutEveryWhere()"
          :disabled="logoutLoading"
        >
          {{ $i18nPresenter.t('Log out everywhere else') }}
        </aha-antd-button>
      </template>
    </aha-section>
  </aha-tab-item>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import UserApi from '@/api/user'

export default {
  data() {
    return {
      logoutLoading: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    titleLogOutEverywhereElse() {
      return this.$i18nPresenter.t('Log out everywhere else')
    },
  },
  methods: {
    async logoutEveryWhere() {
      if (this.logoutLoading) return
      this.logoutLoading = true

      try {
        const resp = await UserApi.logoutEveryWhere(this.currentUser.id)
        utils.setCookieToken(resp.token)
        Vue.http.headers.common.Authorization = `Bearer ${resp.token}`
        const successMessage = this.$i18nPresenter.t('You have successfully logged out from all other devices!')
        utils.showToastSuccess(successMessage)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Logout everywhere else success')
      } catch (error) {
        Sentry.captureException(error)
        const wrongMessage = this.$i18nPresenter.t('Something went wrong!')
        utils.showToastError(wrongMessage)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Logout everywhere else fail')
      }
      this.logoutLoading = false
    },
  },
}
</script>
